



























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Stat from '@/components/Stat.vue';
import VueSlider from 'vue-slider-component';
import { categories, scrapers } from '../data';
import browserWeightedBotScore from '@double-agent/runner/lib/browserWeightedBotScore';

@Component({
  components: {
    Stat,
    VueSlider,
  },
})
export default class ScraperBotOdds extends Vue {
  private agentsType: 'intoli' | 'statcounter' = 'intoli';
  private rotateIP = false;
  private selectedCategories: string[] = [];
  private basicCategories: string[] = ['IP Address', 'User Agent'];

  private customizeKitchenSink = false;
  private readonly categoriesAndLayers: {
    title: string;
    isLayer: boolean;
    implemented: boolean;
  }[] = [];
  private botScores: { [scraper: string]: number } = {};
  private botScoresByCategory: { [scraper: string]: { category: string; botPct: number }[] } = {};
  private basicBotScores: { [scraper: string]: number } = {};
  private basicBotScoresByCategory: {
    [scraper: string]: { [category: string]: number };
  } = {};
  private requestsPerPeriod = 10;
  private isSelectAll = false;
  private customizeScraper = false;
  private popperOptions = {
    modifiers: { flip: { enabled: false } },
    padding: { top: 50, bottom: 50 },
  };
  private showingTip: string = '';

  private requestSliderValues = [10, 100, 1000];
  private updateScoreTimeout: any;

  get agentTypeOptions() {
    return [
      {
        code: 'intoli',
        label: 'Use a Generator (intoli user-agents)',
      },
      {
        code: 'statcounter',
        label: 'Only use the top 2 User Agents (per statcounter)',
      },
    ];
  }

  constructor() {
    super();
    for (const [category, entry] of Object.entries(categories)) {
      const layerTitle = `${entry.layer.toUpperCase()}`;
      if (!this.categoriesAndLayers.some(x => x.title === layerTitle && x.isLayer)) {
        this.categoriesAndLayers.push({
          title: layerTitle,
          isLayer: true,
          implemented: true,
        });
      }

      this.categoriesAndLayers.push({
        title: category,
        isLayer: false,
        implemented: entry.implemented,
      });
      this.selectedCategories.push(category);
    }
  }

  toggleScraperBotDetails(scraper: string) {
    if (this.showingTip === scraper) this.showingTip = '';
    else this.showingTip = scraper;
  }

  clearSelected() {
    this.selectedCategories.length = 0;
    this.updateScores();
    this.isSelectAll = true;
  }

  selectAll() {
    for (const cat of this.categoriesAndLayers.filter(x => !x.isLayer)) {
      if (!this.selectedCategories.includes(cat.title)) this.selectedCategories.push(cat.title);
    }
    this.updateScores();
    this.isSelectAll = false;
  }

  created() {
    this.updateScores();
  }

  @Watch('requestsPerPeriod')
  debounceUpdateScores() {
    if (this.updateScoreTimeout) clearTimeout(this.updateScoreTimeout);
    this.updateScoreTimeout = setTimeout(() => {
      this.updateScores();
    }, 50);
  }

  @Watch('rotateIP')
  @Watch('agentsType')
  updateScores() {
    const activeCategories = this.selectedCategories.filter(category =>
      this.categoriesAndLayers.some(x => !x.isLayer && x.title === category && x.implemented),
    );
    for (const [, scraper] of Object.entries(scrapers)) {
      const scores = browserWeightedBotScore(
        scraper,
        activeCategories,
        this.agentsType,
        this.rotateIP,
        this.requestsPerPeriod,
      );
      this.botScores[scraper.title] = scores.botScore;
      this.botScoresByCategory[scraper.title] = scores.categoryScores;

      const basicScores = browserWeightedBotScore(
        scraper,
        this.basicCategories,
        this.agentsType,
        this.rotateIP,
        this.requestsPerPeriod,
      );
      this.basicBotScores[scraper.title] = basicScores.botScore;
      this.basicBotScoresByCategory[scraper.title] = {};
      for (const entry of basicScores.categoryScores) {
        if (!this.botScoresByCategory[scraper.title].find(x => x.category === entry.category)) {
          this.botScoresByCategory[scraper.title].unshift({
            category: entry.category,
            botPct: undefined as any,
          });
        }
        this.basicBotScoresByCategory[scraper.title][entry.category] = entry.botPct;
      }
    }
    this.$forceUpdate();
  }
}
